import { computed, Injectable, signal } from '@angular/core';
import { SceneSetupPayload } from 'shared';
import { getInitials } from 'utilities';
import { MemberOption } from '../../molecules/member-multiselect-input/member-multiselect-input.interfaces';
import { PriorityValue } from '../../molecules/priority-dropdown/priority-dropdown.interfaces';
import { StatusValue } from '../../molecules/status-dropdown/status-dropdown.interfaces';
import { CreateTaskAssigneeOption } from './create-task-form.interface';

@Injectable()
export class CreateTaskFormStore {
  // --- Form fields ---

  readonly title = signal('New Task');
  readonly description = signal('');
  readonly assignees = signal<CreateTaskAssigneeOption[]>([]);
  readonly watchers = signal<CreateTaskAssigneeOption[]>([]);
  readonly priority = signal<PriorityValue>('Medium');
  readonly status = signal<StatusValue>('Open');
  readonly dueDate = signal<Date | null>(null);
  readonly scene = signal<SceneSetupPayload | null>(null);
  readonly tags = signal('');

  // --- UI state ---

  readonly showMoreDetails = signal(false);

  // --- Derived ---

  readonly selectedAssigneeIds = computed(() => this.assignees().map(a => a.id));
  readonly selectedWatcherIds = computed(() => this.watchers().map(w => w.id));
  readonly hasScene = computed(() => this.scene() !== null);

  readonly sceneThumbnailUrl = computed(() => {
    const sceneData = this.scene();
    if (!sceneData?.thumbnail || typeof sceneData.thumbnail !== 'string') return undefined;
    if (sceneData.thumbnail.startsWith('data:')) return sceneData.thumbnail;
    return undefined;
  });

  memberDropdownOptions(assigneeOptions: CreateTaskAssigneeOption[]): MemberOption[] {
    return assigneeOptions.map(option => ({
      value: option.id,
      label: option.name,
      initials: getInitials(option.name),
      email: option.email,
    }));
  }
}
